import { memo, ReactElement } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Breadcrumbs from '~/ui/components/common/Breadcrumbs';

import { useStoreState } from '~/store/hooks';
import useRole from '~/store/user/hooks/useRole';
import { NETWORK, VIEW_CRISIS_ALLOCATION } from '~/ui/constants/paths';
import { IParams } from '../types';

const AllocationBreadcrumbs = (): ReactElement => {
  const { actTeamId } = useParams<IParams>();
  const { pathname } = useLocation();

  const { clinic: userClinic } = useStoreState(state => state.user.current);
  const clientAllocation = useStoreState(state => state.clientAllocation.current) || [];

  const { isActTeam, isGlobalUser } = useRole();

  const breadcrumbItems = [
    ...(isGlobalUser ? [{ to: NETWORK, title: `${userClinic.name} Teams` }] : []),
    ...(isActTeam
      ? [
          {
            to: {
              pathname: VIEW_CRISIS_ALLOCATION.replace(':actTeamId', actTeamId).replace(
                ':clientAllocationDate',
                String(clientAllocation[0]?.date?.split('T')[0]),
              ),
            },
            title: 'Client Allocation',
          },
        ]
      : []),
    ...(!isActTeam && !isGlobalUser ? [{ to: NETWORK, title: `${userClinic.name} Teams` }] : []),
    { to: pathname, title: 'Edit Crisis Allocation' },
  ];

  return <Breadcrumbs itemsForBreadcrumbs={breadcrumbItems} />;
};

export default memo(AllocationBreadcrumbs);
